/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointmentTranscriptionMessage } from './AppointmentTranscriptionMessage';
import {
    AppointmentTranscriptionMessageFromJSON,
    AppointmentTranscriptionMessageFromJSONTyped,
    AppointmentTranscriptionMessageToJSON,
} from './AppointmentTranscriptionMessage';

/**
 * Shadow-provider (Deepgram) transcript of an appointment. Mirrors AppointmentTranscription one-to-one (same id = appointment id, same message shape) so the two can be diffed apples-to-apples for provider-quality evaluation; lives in its own table so evaluation data never mixes with the clinical record.
 * @export
 * @interface AppointmentTranscriptionComparison
 */
export interface AppointmentTranscriptionComparison {
    /**
     * 
     * @type {string}
     * @memberof AppointmentTranscriptionComparison
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTranscriptionComparison
     */
    tenant_id?: string;
    /**
     * 
     * @type {Array<AppointmentTranscriptionMessage>}
     * @memberof AppointmentTranscriptionComparison
     */
    messages: Array<AppointmentTranscriptionMessage>;
}

/**
 * Check if a given object implements the AppointmentTranscriptionComparison interface.
 */
export function instanceOfAppointmentTranscriptionComparison(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function AppointmentTranscriptionComparisonFromJSON(json: any): AppointmentTranscriptionComparison {
    return AppointmentTranscriptionComparisonFromJSONTyped(json, false);
}

export function AppointmentTranscriptionComparisonFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTranscriptionComparison {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'messages': ((json['messages'] as Array<any>).map(AppointmentTranscriptionMessageFromJSON)),
    };
}

export function AppointmentTranscriptionComparisonToJSON(value?: AppointmentTranscriptionComparison | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'messages': ((value.messages as Array<any>).map(AppointmentTranscriptionMessageToJSON)),
    };
}

